(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gf-article"]) return;
  try {
    
  (function () {
    function init() {
      var rte = document.querySelector('.gfa-rte');
      var toc = document.querySelector('.gfa-toc');
      if (rte && toc) {
        var hs = Array.prototype.slice.call(rte.querySelectorAll('h2'));
        if (hs.length >= 2) {
          var list = toc.querySelector('.gfa-toc__list');
          list.innerHTML = '';
          hs.forEach(function (h, i) {
            if (!h.id) {
              h.id = 'sec-' + i + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
            }
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.href = '#' + h.id;
            a.textContent = h.textContent.trim();
            li.appendChild(a);
            list.appendChild(li);
          });
          toc.hidden = false;
          var links = Array.prototype.slice.call(list.querySelectorAll('a'));
          if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function (entries) {
              entries.forEach(function (e) {
                if (e.isIntersecting) {
                  links.forEach(function (l) {
                    l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id);
                  });
                }
              });
            }, { rootMargin: '-15% 0px -70% 0px' });
            hs.forEach(function (h) { io.observe(h); });
          }
        }
      }
      var copy = document.querySelector('[data-gfa-copy]');
      if (copy && navigator.clipboard && !copy.hasAttribute('data-bound')) {
        copy.setAttribute('data-bound', '');
        copy.addEventListener('click', function () {
          navigator.clipboard.writeText(copy.getAttribute('data-url')).then(function () {
            var t = copy.textContent;
            copy.textContent = 'Copied';
            setTimeout(function () { copy.textContent = t; }, 1600);
          });
        });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    // Theme editor replaces the section DOM on every setting change; rebuild the TOC when that happens.
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-bundle-mix"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // "<variantId>:<qty>,..." for the Cart Transform, which expands the kit line into
    // its real components so stock decrements. Returns '' unless every pick resolved
    // to a variant — a partial spec would expand into fewer components than were sold.
    function bundleSpec(picks) {
      var order = [], qty = {};
      for (var i = 0; i < picks.length; i++) {
        var id = picks[i] && picks[i].vid;
        if (!id) return '';
        if (!qty[id]) { qty[id] = 0; order.push(id); }
        qty[id]++;
      }
      return order.map(function (id) { return id + ':' + qty[id]; }).join(',');
    }

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    function initRoot(root) {
      if (root.hasAttribute('data-gfmx-init')) return;
      root.setAttribute('data-gfmx-init', '');
      var cfgEl = document.getElementById('gfmx-cfg-' + root.dataset.gfmSection);
      if (!cfgEl) return;
      var cfg = JSON.parse(cfgEl.textContent);

      var hgGrid = root.querySelector('[data-gfm-hg-grid]');
      var sockGrid = root.querySelector('[data-gfm-sock-grid]');
      var chairWrap = root.querySelector('[data-gfm-chairs]');
      var hgSlot = root.querySelector('[data-gfm-slot="headgear"]');
      var sockSlots = root.querySelectorAll('[data-gfm-slot="sock"]');
      var chairLine = root.querySelector('[data-gfm-chairline]');
      var chairLineVal = root.querySelector('[data-gfm-chairline-val]');
      var countEl = root.querySelector('[data-gfm-count]');
      var progEl = root.querySelector('[data-gfm-prog]');
      var progWrap = root.querySelector('[data-gfm-progwrap]');
      var hintEl = root.querySelector('[data-gfm-hint]');
      var priceEl = root.querySelector('[data-gfm-price]');
      var saveEl = root.querySelector('[data-gfm-save]');
      var saveAmtEl = root.querySelector('[data-gfm-save-amt]');
      var saveValEl = root.querySelector('[data-gfm-save-val]');
      var addBtn = root.querySelector('[data-gfm-add]');
      var addText = root.querySelector('[data-gfm-addtext]');
      var errEl = root.querySelector('[data-gfm-err]');
      var sBar = root.querySelector('[data-gfm-sticky]');
      var sCount = root.querySelector('[data-gfm-scount]');
      var sPrice = root.querySelector('[data-gfm-sprice]');
      var sBtn = root.querySelector('[data-gfm-sticky-add]');
      var sBtnText = root.querySelector('[data-gfm-saddtext]');

      var hg = null;        // { colour, size, img, vid }
      var socks = [];       // [{ colour, size, img, vid }]
      var chairIdx = null;  // index into cfg.variants

      var plusIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>';

      function money(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function currentVariant() {
        if (!cfg.chairStep) return cfg.variants[0];
        return chairIdx === null ? cfg.variants[0] : cfg.variants[chairIdx];
      }

      function picksDone() {
        var n = socks.length;
        if (cfg.includeHeadgear && hg) n += 1;
        if (cfg.chairStep && chairIdx !== null) n += 1;
        return n;
      }

      function isComplete() {
        if (cfg.includeHeadgear && !hg) return false;
        if (socks.length < cfg.sockCount) return false;
        if (cfg.chairStep && chairIdx === null) return false;
        return true;
      }

      function fillSlot(slot, p, label, onRemove) {
        slot.classList.add('is-filled');
        slot.classList.remove('is-next');
        slot.innerHTML =
          (p.img ? '<img class="gfbnd-slot__img" src="' + esc(p.img) + '" alt="">' : '') +
          '<span class="gfbnd-slot__size">' + esc(label) + '</span>' +
          '<button type="button" class="gfbnd-slot__x" aria-label="Remove ' + esc(p.colour) + '">&times;</button>';
        slot.title = p.colour + ' / ' + p.size;
        slot.querySelector('.gfbnd-slot__x').addEventListener('click', onRemove);
      }

      function emptySlot(slot, label, isNext) {
        slot.classList.remove('is-filled');
        slot.classList.toggle('is-next', !!isNext);
        slot.removeAttribute('title');
        slot.innerHTML = '<span class="gfbnd-slot__add">' + plusIcon + '<span>' + label + '</span></span>';
      }

      function stepState(stepName, done) {
        var step = root.querySelector('[data-gfm-step="' + stepName + '"]');
        if (!step) return;
        step.classList.toggle('is-done', done);
        var tick = step.querySelector('[data-gfm-step-tick]');
        if (tick) tick.hidden = !done;
      }

      function tileBadges(grid, picks) {
        if (!grid) return;
        grid.querySelectorAll('.gfbnd-colour').forEach(function (tile) {
          var name = tile.dataset.colour;
          var c = picks.filter(function (p) { return p.colour === name; }).length;
          tile.classList.toggle('is-picked', c > 0);
          var b = tile.querySelector('[data-colour-qty]');
          if (b) { b.textContent = c; b.hidden = c === 0; }
        });
      }

      function render() {
        var n = picksDone();
        var full = isComplete();
        var v = currentVariant();

        if (countEl) countEl.textContent = n;
        if (sCount) sCount.textContent = n;
        if (progEl) progEl.style.width = (cfg.picksTotal ? (n / cfg.picksTotal * 100) : 0) + '%';
        if (progWrap) progWrap.setAttribute('aria-valuenow', n);

        // headgear slot
        if (hgSlot) {
          if (hg) fillSlot(hgSlot, hg, hg.size, function () { hg = null; render(); });
          else emptySlot(hgSlot, 'Headgear', true);
        }
        // sock slots fill in order; removing a pick splices and reindexes
        sockSlots.forEach(function (slot, i) {
          var p = socks[i];
          if (p) fillSlot(slot, p, p.size, function () { socks.splice(i, 1); render(); });
          else emptySlot(slot, 'Socks', i === socks.length && (!cfg.includeHeadgear || !!hg));
        });

        tileBadges(hgGrid, hg ? [hg] : []);
        tileBadges(sockGrid, socks);
        if (sockGrid) sockGrid.classList.toggle('is-full', socks.length >= cfg.sockCount);

        stepState('headgear', !!hg);
        stepState('socks', socks.length >= cfg.sockCount);
        stepState('chair', chairIdx !== null);

        if (chairWrap) {
          chairWrap.querySelectorAll('[data-gfm-chair]').forEach(function (c) {
            var picked = Number(c.dataset.gfmChair) === chairIdx;
            c.classList.toggle('is-picked', picked);
            c.setAttribute('aria-checked', picked ? 'true' : 'false');
          });
        }
        if (chairLine) {
          chairLine.classList.toggle('is-picked', chairIdx !== null);
          if (chairLineVal) chairLineVal.textContent = (chairIdx === null || !cfg.chairs[chairIdx]) ? 'Not picked yet' : cfg.chairs[chairIdx].title;
        }

        // price + savings track the chosen variant
        if (priceEl) priceEl.textContent = money(v.price);
        if (sPrice) sPrice.textContent = money(v.price);
        var chairVal = 0;
        if (cfg.chairStep && cfg.chairs.length) {
          chairVal = (chairIdx === null ? cfg.chairs[0] : cfg.chairs[chairIdx]).standalone;
        }
        var value = cfg.baseValue + chairVal;
        var savings = value - v.price;
        if (saveEl) {
          saveEl.hidden = savings <= 0;
          if (saveAmtEl) saveAmtEl.textContent = money(savings);
          if (saveValEl) saveValEl.textContent = money(value);
        }

        if (hintEl) {
          var msg;
          if (full) { msg = 'Kit complete. Nice work.'; }
          else if (cfg.includeHeadgear && !hg) { msg = 'Start with your headgear: pick a colour and tap a size.'; }
          else if (socks.length < cfg.sockCount) {
            var left = cfg.sockCount - socks.length;
            msg = left + ' pair' + (left === 1 ? '' : 's') + ' of grip socks to go.';
          } else { msg = 'Last step: pick your chair.'; }
          hintEl.classList.toggle('is-full', full);
          hintEl.textContent = msg;
        }

        var label = full ? 'Add kit to cart' : 'Finish your kit';
        if (addBtn) { addBtn.disabled = !full; addBtn.classList.toggle('is-ready', full); }
        if (addText) addText.textContent = label;
        if (sBtn) { sBtn.disabled = !full; sBtn.classList.toggle('is-ready', full); }
        if (sBtnText) sBtnText.textContent = full ? 'Add to cart' : 'Keep going';
      }

      // headgear: one pick, re-picking replaces it
      if (hgGrid) {
        hgGrid.querySelectorAll('.gfbnd-size').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            var tile = btn.closest('.gfbnd-colour');
            hg = { colour: tile.dataset.colour, size: btn.dataset.addSize, img: tile.dataset.img || '', vid: btn.dataset.addVid || '' };
            if (errEl) errEl.hidden = true;
            tile.classList.remove('just-added'); void tile.offsetWidth; tile.classList.add('just-added');
            render();
          });
        });
      }

      // socks: capped at sockCount
      if (sockGrid) {
        sockGrid.querySelectorAll('.gfbnd-size').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled || socks.length >= cfg.sockCount) return;
            var tile = btn.closest('.gfbnd-colour');
            socks.push({ colour: tile.dataset.colour, size: btn.dataset.addSize, img: tile.dataset.img || '', vid: btn.dataset.addVid || '' });
            if (errEl) errEl.hidden = true;
            tile.classList.remove('just-added'); void tile.offsetWidth; tile.classList.add('just-added');
            render();
          });
        });
      }

      // chair: radio behaviour
      if (chairWrap) {
        chairWrap.querySelectorAll('[data-gfm-chair]').forEach(function (c) {
          c.addEventListener('click', function () {
            chairIdx = Number(c.dataset.gfmChair);
            if (errEl) errEl.hidden = true;
            render();
          });
        });
      }

      function addToCart() {
        if (!isComplete()) return;
        var props = {};
        if (cfg.includeHeadgear && hg) props['Headgear'] = hg.colour + ' / ' + hg.size;
        socks.forEach(function (p, i) { props['Pair ' + (i + 1)] = p.colour + ' / ' + p.size; });
        // hidden from the customer (leading _) but lands on the order. The chair is a
        // real product too, so it rides in the spec alongside the headgear and socks.
        var picks = [];
        if (cfg.includeHeadgear && hg) picks.push(hg);
        socks.forEach(function (p) { picks.push(p); });
        if (cfg.chairStep && chairIdx !== null && cfg.chairs[chairIdx]) picks.push({ vid: cfg.chairs[chairIdx].variantId });
        var spec = bundleSpec(picks);
        if (spec) props['_gf_bundle'] = spec;
        var v = currentVariant();
        var btns = [addBtn, sBtn];
        btns.forEach(function (b) { if (b) b.disabled = true; });
        if (addText) addText.textContent = 'Adding...';
        var sectionIds = [];
        document.querySelectorAll('cart-items-component').forEach(function (el) {
          if (el.dataset.sectionId && sectionIds.indexOf(el.dataset.sectionId) === -1) sectionIds.push(el.dataset.sectionId);
        });
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: v.id, quantity: 1, properties: props, sections: sectionIds.join(',') })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart.'); });
          return r.json();
        }).then(function (added) {
          fetch('/cart.js').then(function (rr) { return rr.json(); }).then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: {
              resource: cart, sourceId: 'gf-bundle-mix',
              data: { source: 'gf-bundle-mix', itemCount: cart.item_count, sections: added.sections }
            } }));
          });
          hg = null; socks.length = 0; chairIdx = null;
          btns.forEach(function (b) { if (b) b.disabled = false; });
          render();
        }).catch(function (err) {
          if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
          btns.forEach(function (b) { if (b) b.disabled = false; });
          render();
        });
      }

      if (addBtn) addBtn.addEventListener('click', addToCart);
      if (sBtn) sBtn.addEventListener('click', addToCart);

      var watch = sockGrid || hgGrid;
      if (sBar && watch && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { sBar.hidden = e.isIntersecting; });
        }, { rootMargin: '0px 0px -120px 0px' }).observe(watch);
      }

      render();
    }

    function initAll(scope) {
      (scope && scope.querySelectorAll ? scope : document).querySelectorAll('.gfmx[data-gfm-section]').forEach(initRoot);
    }
    initAll();
    // The theme editor swaps a section's markup without re-running this bundle; re-bind for the reloaded section.
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // "<variantId>:<qty>,..." for the Cart Transform, which expands the bundle line
    // into its real components so stock decrements. Returns '' unless every pick
    // resolved to a variant — a partial spec would expand into fewer components
    // than were actually sold.
    function bundleSpec(picks) {
      var order = [], qty = {};
      for (var i = 0; i < picks.length; i++) {
        var id = picks[i] && picks[i].vid;
        if (!id) return '';
        if (!qty[id]) { qty[id] = 0; order.push(id); }
        qty[id]++;
      }
      return order.map(function (id) { return id + ':' + qty[id]; }).join(',');
    }

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    function initRoot(root) {
      if (root.hasAttribute('data-gfbnd-init')) return;
      root.setAttribute('data-gfbnd-init', '');
      var cfgEl = document.getElementById('gfbnd-cfg-' + root.dataset.sectionId);
      if (!cfgEl) return;
      var cfg = JSON.parse(cfgEl.textContent);
      var total = cfg.pairsTotal;
      var paid = cfg.paidPairs || Math.ceil(total / 2);

      var grid = root.querySelector('[data-gfb-grid]');
      var slots = root.querySelectorAll('[data-gfb-slots] .gfbnd-slot');
      var countEl = root.querySelector('[data-gfb-count]');
      var progEl = root.querySelector('[data-gfb-prog]');
      var progWrap = root.querySelector('[data-gfb-progwrap]');
      var hintEl = root.querySelector('[data-gfb-hint]');
      var addBtn = root.querySelector('[data-gfb-add]');
      var addText = root.querySelector('[data-gfb-addtext]');
      var errEl = root.querySelector('[data-gfb-err]');
      var sBar = root.querySelector('[data-gfb-sticky]');
      var sCount = root.querySelector('[data-gfb-scount]');
      var sBtn = root.querySelector('[data-gfb-sticky-add]');
      var sBtnText = root.querySelector('[data-gfb-saddtext]');

      var chosen = []; // { colour, size, img, vid }

      var plusIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>';

      function render() {
        var n = chosen.length;
        var full = n >= total;

        if (countEl) countEl.textContent = n;
        if (sCount) sCount.textContent = n;
        if (progEl) progEl.style.width = (total ? (n / total * 100) : 0) + '%';
        if (progWrap) progWrap.setAttribute('aria-valuenow', n);

        // slots fill in order
        slots.forEach(function (slot, i) {
          var p = chosen[i];
          if (p) {
            slot.classList.add('is-filled');
            slot.classList.remove('is-next');
            slot.innerHTML =
              (p.img ? '<img class="gfbnd-slot__img" src="' + esc(p.img) + '" alt="">' : '') +
              '<span class="gfbnd-slot__size">' + esc(p.size) + '</span>' +
              '<button type="button" class="gfbnd-slot__x" aria-label="Remove ' + esc(p.colour) + '">&times;</button>';
            slot.title = p.colour + ' / ' + p.size;
            slot.querySelector('.gfbnd-slot__x').addEventListener('click', function () { chosen.splice(i, 1); render(); });
          } else {
            slot.classList.remove('is-filled');
            slot.classList.toggle('is-next', i === n);
            slot.removeAttribute('title');
            slot.innerHTML = '<span class="gfbnd-slot__add">' + plusIcon + '<span>Add</span></span>';
          }
        });

        // tile state
        grid.querySelectorAll('.gfbnd-colour').forEach(function (tile) {
          var name = tile.dataset.colour;
          var c = chosen.filter(function (p) { return p.colour === name; }).length;
          tile.classList.toggle('is-picked', c > 0);
          var b = tile.querySelector('[data-colour-qty]');
          if (b) { b.textContent = c; b.hidden = c === 0; }
        });

        grid.classList.toggle('is-full', full);
        if (hintEl) {
          var inFree = !cfg.plainPricing && n >= paid && (total - paid) > 0;
          hintEl.classList.toggle('is-full', full);
          hintEl.classList.toggle('is-free', inFree && !full);
          var msg;
          if (full) { msg = 'Bundle complete. Nice work.'; }
          else if (n === 0) { msg = 'Tap a size on any colour to add it. Mix and match freely.'; }
          else if (inFree) { msg = 'Every pair from here is free. ' + (total - n) + ' to go.'; }
          else { msg = (total - n) + ' more pair' + ((total - n) === 1 ? '' : 's') + ' to build your bundle.'; }
          hintEl.textContent = msg;
        }

        var label = full ? 'Add bundle to cart' : ('Choose ' + (total - n) + ' more pair' + ((total - n) === 1 ? '' : 's'));
        if (addBtn) { addBtn.disabled = !full; addBtn.classList.toggle('is-ready', full); }
        if (addText) addText.textContent = label;
        if (sBtn) { sBtn.disabled = !full; sBtn.classList.toggle('is-ready', full); }
        if (sBtnText) sBtnText.textContent = full ? 'Add to cart' : ('Choose ' + (total - n));
      }

      // add a pair when a size button is tapped
      grid.querySelectorAll('.gfbnd-size').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled || chosen.length >= total) return;
          var tile = btn.closest('.gfbnd-colour');
          chosen.push({ colour: tile.dataset.colour, size: btn.dataset.addSize, img: tile.dataset.img || '', vid: btn.dataset.addVid || '' });
          if (errEl) errEl.hidden = true;
          tile.classList.remove('just-added'); void tile.offsetWidth; tile.classList.add('just-added');
          render();
        });
      });

      function addToCart() {
        if (chosen.length < total) return;
        var props = {};
        chosen.forEach(function (p, i) { props['Pair ' + (i + 1)] = p.colour + ' / ' + p.size; });
        // hidden from the customer (leading _) but lands on the order
        var spec = bundleSpec(chosen);
        if (spec) props['_gf_bundle'] = spec;
        var btns = [addBtn, sBtn];
        btns.forEach(function (b) { if (b) b.disabled = true; });
        if (addText) addText.textContent = 'Adding...';
        // Collect the cart drawer's section id(s) so Shopify re-renders them in the add response.
        var sectionIds = [];
        document.querySelectorAll('cart-items-component').forEach(function (el) {
          if (el.dataset.sectionId && sectionIds.indexOf(el.dataset.sectionId) === -1) sectionIds.push(el.dataset.sectionId);
        });
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: cfg.variantId, quantity: 1, properties: props, sections: sectionIds.join(',') })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart.'); });
          return r.json();
        }).then(function (added) {
          // Stay on the bundle page and open the cart drawer instead of redirecting to /cart.
          fetch('/cart.js').then(function (rr) { return rr.json(); }).then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: {
              resource: cart, sourceId: 'gf-bundle',
              data: { source: 'gf-bundle', itemCount: cart.item_count, sections: added.sections }
            } }));
          });
          // Reset the builder so a completed bundle can't be added twice by accident.
          chosen.length = 0;
          btns.forEach(function (b) { if (b) b.disabled = false; });
          render();
        }).catch(function (err) {
          if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
          btns.forEach(function (b) { if (b) b.disabled = false; });
          render();
        });
      }

      if (addBtn) addBtn.addEventListener('click', addToCart);
      if (sBtn) sBtn.addEventListener('click', addToCart);

      if (sBar && grid && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { sBar.hidden = e.isIntersecting; });
        }, { rootMargin: '0px 0px -120px 0px' }).observe(grid);
      }

      render();
    }

    function initAll(scope) {
      (scope && scope.querySelectorAll ? scope : document).querySelectorAll('.gfbnd[data-section-id]').forEach(initRoot);
    }
    initAll();
    // The theme editor swaps a section's markup without re-running this bundle; re-bind for the reloaded section.
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-bundles-tabs"] && !Shopify.designMode) return;
  try {
    
  class GFBundleTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-gfbt-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-gfbt-panel]'));
      this._cleanup = [];

      this.tabs.forEach((tab) => {
        this._on(tab, 'click', () => this.activate(tab.dataset.gfbtTab, true));
        this._on(tab, 'keydown', (e) => this.onTabKeydown(e));
      });

      this.panels.forEach((panel) => this.initPanel(panel));
    }

    disconnectedCallback() {
      this._cleanup.forEach((fn) => fn());
      this._cleanup = [];
    }

    _on(el, type, handler, opts) {
      el.addEventListener(type, handler, opts);
      this._cleanup.push(() => el.removeEventListener(type, handler, opts));
    }

    get reduceMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /* ---------- Tabs ---------- */

    activate(index, focus) {
      this.tabs.forEach((tab) => {
        const on = tab.dataset.gfbtTab === String(index);
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (on && focus) tab.focus();
      });

      this.panels.forEach((panel) => {
        const on = panel.dataset.gfbtPanel === String(index);
        panel.hidden = !on;
        if (!on) return;
        // Metrics are only readable once the panel is visible again.
        requestAnimationFrame(() => {
          const track = panel.querySelector('[data-gfbt-track]');
          if (track) track.scrollLeft = 0;
          this.sync(panel);
        });
      });
    }

    onTabKeydown(e) {
      const keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
      if (keys.indexOf(e.key) === -1) return;
      e.preventDefault();

      const current = this.tabs.indexOf(e.currentTarget);
      let next = current;

      if (e.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
      if (e.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
      if (e.key === 'Home') next = 0;
      if (e.key === 'End') next = this.tabs.length - 1;

      this.activate(this.tabs[next].dataset.gfbtTab, true);
    }

    /* ---------- Carousel ---------- */

    initPanel(panel) {
      const track = panel.querySelector('[data-gfbt-track]');
      if (!track) return;

      const prev = panel.querySelector('[data-gfbt-prev]');
      const next = panel.querySelector('[data-gfbt-next]');
      const dots = Array.from(panel.querySelectorAll('[data-gfbt-dot]'));

      if (prev) this._on(prev, 'click', () => this.page(track, -1));
      if (next) this._on(next, 'click', () => this.page(track, 1));

      dots.forEach((dot) => {
        this._on(dot, 'click', () => {
          const slide = track.children[Number(dot.dataset.gfbtDot)];
          if (!slide) return;
          track.scrollTo({
            left: slide.offsetLeft - this.padLeft(track),
            behavior: this.reduceMotion ? 'auto' : 'smooth',
          });
        });
      });

      let ticking = false;
      this._on(
        track,
        'scroll',
        () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            ticking = false;
            this.sync(panel);
          });
        },
        { passive: true }
      );

      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(() => this.sync(panel));
        ro.observe(track);
        this._cleanup.push(() => ro.disconnect());
      }

      this.sync(panel);
    }

    padLeft(track) {
      return parseFloat(getComputedStyle(track).paddingLeft) || 0;
    }

    page(track, dir) {
      track.scrollBy({
        left: dir * Math.max(track.clientWidth * 0.9, 1),
        behavior: this.reduceMotion ? 'auto' : 'smooth',
      });
    }

    sync(panel) {
      const track = panel.querySelector('[data-gfbt-track]');
      if (!track || panel.hidden) return;

      const max = track.scrollWidth - track.clientWidth;
      const x = track.scrollLeft;

      const prev = panel.querySelector('[data-gfbt-prev]');
      const next = panel.querySelector('[data-gfbt-next]');
      if (prev) prev.disabled = x <= 1;
      if (next) next.disabled = x >= max - 1;

      const dots = Array.from(panel.querySelectorAll('[data-gfbt-dot]'));
      if (!dots.length) return;

      const pad = this.padLeft(track);
      let best = 0;
      let bestDelta = Infinity;

      Array.from(track.children).forEach((slide, i) => {
        const delta = Math.abs(slide.offsetLeft - pad - x);
        if (delta < bestDelta) {
          bestDelta = delta;
          best = i;
        }
      });

      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === best));
    }
  }

  if (!customElements.get('gf-bundle-tabs')) {
    customElements.define('gf-bundle-tabs', GFBundleTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-collection"] && !Shopify.designMode) return;
  try {
    
  /* Quick add: pick a size (or single variant) and POST to the cart without leaving the grid. */
  (function () {
    function closePanels(except) {
      document.querySelectorAll('.gfc-qa.is-open').forEach(function (q) {
        if (q !== except) {
          q.classList.remove('is-open');
          var t = q.querySelector('[data-gfc-qa-open]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function bumpCartCount(count) {
      try {
        document.querySelectorAll('.cart-bubble').forEach(function (b) { b.classList.remove('visually-hidden', 'hidden'); });
        document.querySelectorAll('.cart-bubble__text-count').forEach(function (c) { c.classList.remove('hidden'); c.textContent = count; });
      } catch (e) {}
    }

    function addToCart(btn, qa) {
      if (btn.disabled || qa.classList.contains('is-loading')) return;
      var id = btn.getAttribute('data-gfc-qa-add');
      if (!id) return;
      qa.classList.add('is-loading');
      fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add'); });
        return fetch(Theme.routes.cart_url + '.js').then(function (rr) { return rr.json(); });
      }).then(function (cart) {
        bumpCartCount(cart.item_count);
        // Open + sync the Horizon cart drawer. The previous 'cart:refresh' event was dead (nothing
        // listened for it), so the drawer kept showing a stale cart missing the just-added item.
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: {
          resource: cart, sourceId: 'gf-collection',
          data: { source: 'gf-collection', itemCount: cart.item_count }
        } }));
        qa.classList.remove('is-loading');
        qa.classList.add('is-added');
        setTimeout(function () { qa.classList.remove('is-added', 'is-open'); }, 1700);
      }).catch(function () {
        qa.classList.remove('is-loading');
        qa.classList.add('is-error');
        setTimeout(function () { qa.classList.remove('is-error'); }, 1800);
      });
    }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-gfc-qa-open]');
      if (openBtn) {
        e.preventDefault();
        var qa = openBtn.closest('.gfc-qa');
        var willOpen = !qa.classList.contains('is-open');
        closePanels(qa);
        qa.classList.toggle('is-open', willOpen);
        openBtn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        return;
      }
      var closeBtn = e.target.closest('[data-gfc-qa-close]');
      if (closeBtn) { e.preventDefault(); closePanels(null); return; }
      var addBtn = e.target.closest('[data-gfc-qa-add]');
      if (addBtn) { e.preventDefault(); addToCart(addBtn, addBtn.closest('.gfc-qa')); return; }
      if (!e.target.closest('.gfc-qa')) closePanels(null);
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(null); });
  })();

  /* Size guide popup (native <dialog>) */
  (function () {
    var dlg = document.querySelector('[data-gfc-sg-dialog]');
    if (!dlg) return;
    document.querySelectorAll('[data-gfc-sg-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      });
    });
    var c = dlg.querySelector('[data-gfc-sg-close]');
    if (c) c.addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) {
      var r = dlg.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dlg.close();
    });
  })();
  // Bundle-type pill bar (bundles template): client-side filter, deep-linkable via ?type=
  (function () {
    var bar = document.querySelector('[data-gfc-typebar]');
    if (!bar) return;
    var pills = bar.querySelectorAll('[data-gfc-type]');
    var cards = document.querySelectorAll('.gfc-card[data-gfc-btype]');

    function apply(type) {
      pills.forEach(function (p) {
        var on = p.dataset.gfcType === type;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      cards.forEach(function (c) {
        c.classList.toggle('gfc-typehide', type !== 'all' && c.dataset.gfcBtype !== type);
      });
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        var type = p.dataset.gfcType;
        apply(type);
        var url = new URL(window.location.href);
        if (type === 'all') url.searchParams.delete('type');
        else url.searchParams.set('type', type);
        history.replaceState(null, '', url);
      });
    });

    // deep link: /collections/bundles?type=pilates preselects a pill
    var initial = new URLSearchParams(window.location.search).get('type');
    if (initial && bar.querySelector('[data-gfc-type="' + CSS.escape(initial) + '"]')) apply(initial);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.gfp[data-section-id]').forEach(function (root) {
      var data = window.__gfpData && window.__gfpData[root.dataset.sectionId];
      if (!data) return;

      var idInput = root.querySelector('[data-gfp-id]');
      var priceEl = root.querySelector('[data-gfp-price]');
      var compareEl = root.querySelector('[data-gfp-compare]');
      var addBtn = root.querySelector('[data-gfp-add]');
      var addText = root.querySelector('[data-gfp-addtext]');
      var slides = root.querySelectorAll('.gfp-stage__slide');
      var thumbs = root.querySelectorAll('.gfp-thumb');
      var stage = root.querySelector('.gfp-stage');
      var optInputs = root.querySelectorAll('[data-opt-input]');
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

      function money(cents) { return data.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2)).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)); }

      // mobile lays the stage out as a horizontal swiper; desktop keeps the crossfade
      function isSwiper() { return stage && stage.scrollWidth - stage.clientWidth > 5; }

      function showMedia(mid) {
        if (!mid) return;
        slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId == mid); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumbFor == mid); });
        if (isSwiper()) {
          var target = root.querySelector('.gfp-stage__slide[data-media-id="' + mid + '"]');
          if (target) stage.scrollTo({ left: target.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }

      function currentSelection() {
        var sel = [];
        root.querySelectorAll('[data-opt-input]:checked').forEach(function (i) { sel[parseInt(i.dataset.optInput, 10)] = i.value; });
        return sel;
      }

      function findVariant(sel) {
        return data.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === sel[i]; });
        });
      }

      function update(initial) {
        var sel = currentSelection();
        var v = data.variants.length === 1 ? data.variants[0] : findVariant(sel);
        if (!v) {
          if (addText) addText.textContent = 'Unavailable';
          if (addBtn) addBtn.disabled = true;
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; }
          else { compareEl.hidden = true; }
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          if (addText) addText.textContent = v.available ? 'Add to Cart' : 'Sold Out';
        }
        // low stock — mirrors the Liquid rule above: tracked, positive, at or under threshold
        var lowEl = root.querySelector('[data-gfp-lowstock]');
        if (lowEl) {
          var lowTxt = lowEl.querySelector('[data-gfp-lowstock-text]');
          var inv = v.inventory;
          if (data.lowStockEnabled && data.lowStockText && inv !== null && inv > 0 && inv <= data.lowStockThreshold) {
            if (lowTxt) lowTxt.textContent = String(data.lowStockText).replace('[count]', inv);
            lowEl.hidden = false;
          } else {
            lowEl.hidden = true;
          }
        }
        var sp = document.querySelector('[data-gfp-sticky-price]');
        if (sp) sp.textContent = money(v.price);
        var sb = document.querySelector('[data-gfp-sticky-add]');
        if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? 'Add to Cart' : 'Sold Out'; }
        if (v.featured_media_id) showMedia(v.featured_media_id);
        // reflect selected colour name
        root.querySelectorAll('[data-opt-selected]').forEach(function (el) {
          var idx = parseInt(el.dataset.optSelected, 10);
          if (sel[idx]) el.textContent = sel[idx];
        });
        // keep the URL shareable / correct for the chosen variant
        if (!initial) try {
          var url = new URL(window.location);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url);
        } catch (e) {}
      }

      optInputs.forEach(function (i) { i.addEventListener('change', update); });

      // thumbnails
      thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.thumbFor); }); });

      // mobile swipe: highlight the thumbnail of whichever slide the swiper settles on
      if (stage) {
        var raf;
        stage.addEventListener('scroll', function () {
          if (!isSwiper()) return;
          window.cancelAnimationFrame(raf);
          raf = window.requestAnimationFrame(function () {
            var slide = slides[Math.round(stage.scrollLeft / stage.clientWidth)];
            if (slide) thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumbFor == slide.dataset.mediaId); });
          });
        }, { passive: true });
      }

      // quantity
      var qtyIn = root.querySelector('[data-gfp-qtyin]');
      root.querySelectorAll('[data-gfp-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = parseInt(b.dataset.gfpQty, 10);
          var val = Math.max(1, (parseInt(qtyIn.value, 10) || 1) + step);
          qtyIn.value = val;
        });
      });

      // mobile sticky bar: show after the main buy button scrolls out of view
      var bar = document.querySelector('[data-gfp-sticky]');
      var form = root.querySelector('#gfp-form');
      if (bar && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            bar.hidden = e.isIntersecting;
            // while the fixed bar is showing, reserve its height so it never covers the footer/reviews
            document.body.style.paddingBottom = e.isIntersecting ? '' : bar.offsetHeight + 'px';
          });
        }, { rootMargin: '0px 0px -40px 0px' }).observe(addBtn);
        var sb = document.querySelector('[data-gfp-sticky-add]');
        if (sb && form) sb.addEventListener('click', function () { form.querySelector('[name="add"]').click(); });
      }

      // size guide popup (native <dialog>): open from the "Size guide" link, close on button / backdrop / Esc
      var sgDialog = root.querySelector('[data-gfp-sg-dialog]');
      if (sgDialog) {
        root.querySelectorAll('[data-gfp-sg-open]').forEach(function (b) {
          b.addEventListener('click', function () {
            if (typeof sgDialog.showModal === 'function') sgDialog.showModal();
            else sgDialog.setAttribute('open', '');
          });
        });
        var sgClose = sgDialog.querySelector('[data-gfp-sg-close]');
        if (sgClose) sgClose.addEventListener('click', function () { sgDialog.close(); });
        sgDialog.addEventListener('click', function (e) {
          var r = sgDialog.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) sgDialog.close();
        });
      }

      update(true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
